// extracted by mini-css-extract-plugin
module.exports = {"ko-KR":"spinner_ko-KR__MllFI","impressionTrackingContainer":"spinner_impressionTrackingContainer__kGWJl","spinner":"spinner_spinner___C5O9","rotate":"spinner_rotate__hnHsD"};